import * as React from "react";
import { CustomButton, ButtonType, ModalBody, Modal, ModalSize, ModalFooter, CustomSubmitButton } from "soprasteria-ui-library";
import { useAuth } from "../../../../App";
import { OrthodonticReferralAdministrationApi } from "../../../../api/OrthodonticReferralAdministrationApi";

interface IOrthodonticReferralMarkAsReadButton {
    orthodonticReferralId: number;
    getOrthodonticReferral: (id: number) => void;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
}


export const OrthodonticReferralMarkAsReadButton: React.FunctionComponent<IOrthodonticReferralMarkAsReadButton> = ({ orthodonticReferralId, getOrthodonticReferral, changeSuccessMessage, changeErrorMessage }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralAdministrationApi(auth);
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const markAnswerAsRead = () => {
        setIsSubmitting(true);
        api.markAnswerAsRead(orthodonticReferralId, () => {
            document.getElementById("close-mark-answer-as-read-modal")?.click();
            getOrthodonticReferral(orthodonticReferralId);
            changeSuccessMessage("Remissvaret har markerats som läst");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsSubmitting(false);
        })
    }

    return (
        <>
            <CustomSubmitButton onButtonSubmit={() => { document.getElementById("open-mark-answer-as-read")?.click(); }}>Markera remissvar som läst</CustomSubmitButton>
            <CustomButton id="open-mark-answer-as-read" buttonType={ButtonType.general} buttonText="" data-toggle="modal" data-target="#mark-answer-as-read-modal" hidden />
            <Modal header="Markera remissvar som läst" id="mark-answer-as-read-modal" modalSize={ModalSize.normal}>
                <ModalBody>
                    <p>Är du säker på att du vill markera remissvaret som läst?</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-mark-answer-as-read-modal" />
                    <CustomSubmitButton onButtonSubmit={markAnswerAsRead} isLoading={isSubmitting}>Ja</CustomSubmitButton>
                </ModalFooter>
            </Modal>
        </>
    )
}